import { TypeEliModalFields } from 'contentful-types'
import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import EliModal from './EliModal'

const ContentfulEliModal = withContentful<TypeEliModalFields>(EliModal, {})
export default ContentfulEliModal
